/**
 * Created by tong on 2018/3/3.
 */
import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {list, stockScreening, materialScreening} from '../../service/inventoryQuery';
import {Cascader} from 'antd';
/*获取列表数据,仓库类型筛选,物料类别筛选接口*/
import {Store, Actions} from './store';
import {openNotice} from "../../utils";
import {proDetailNameScreening} from '../../service/product';
import {treeList2} from "../../service/org";

class CustomerManagement extends React.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            options: [],
            middleData: [],
            stock_type: [],
            inv_type: [{
                "value": "库存",
                "text": "库存"
            }, {
                "value": "非库存",
                "text": "非库存"
            }, {
                "value": "定制",
                "text": "定制"
            }, {
                "value": "专属定制",
                "text": "专属定制"
            }, {
                "value": "退市",
                "text": "退市"
            }, {
                "value": "",
                "text": ""
            }],
            objType_type: [],
            objDetail: [],
            rows: [],
            total: 0,
            searchObj: {
                objCode: '',
                objName: '',
                orgId: '',
                stock: '', /*仓库*/
                objType: '', /*物料类别*/
                detailType: '', /*物料类别*/
                invType: '',
                p: 1,
                s: 20,
                detailCode: '',
                channelCode: this.channelData.split('|')[1] || '',
            },
            loading: false,
            cascaderValue: [],
            tree: [],
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'customerManagement') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
        }
    };

    componentWillMount() { //准备数据
        const self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                }
            });
        }
        stockScreening().then(res => { //仓库
            if (res.status) {
                // let arr = [
                //     {
                //         text: '全部',
                //         value: ''
                //     }
                // ];
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.delvName,
                        value: x.id
                    })
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({stock_type: arr})
                    }
                }, 0);
            }
        });
        materialScreening().then(res => { //物料类别
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({
                            objType_type: arr,
                            middleData: res.data
                        })
                    }
                }, 0);
            }
        });
        treeList2('').then(result => {
            if (result.status) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                this.setState({
                    tree: result.data
                })
            } else {
                openNotice('warning', result.message);
            }
        })
    };

    componentDidMount() {
        this.mounted = true;
        // this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /**
     * 明细类接口
     * @param id
     */
    getProDetailName_type = (id) => {
        proDetailNameScreening(id).then(res => { //明细类
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                this.setState({objDetail: arr},)
            }
        })
    }

    /*筛选*/
    setFilterParam(name, value) {
        // console.log(name + ':\t' + value);
        //     console.log(this.state.middleData)
        if (name === 'middleCode') {
            const arr = this.state.middleData.filter(item => item.code === value);
            let id = '';
            if (arr.length > 0) {
                id = arr[0].id;
            }
            this.getProDetailName_type(id);
        }

        if (name === 'lastOperationTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    lastOperationTimeStart: value.from,
                    lastOperationTimeEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                objCode: '',
                objDiscription: '',
                orgId: '',
                objName: '',
                invType: '',
                stock: '', /*仓库*/
                objType: '', /*物料类别*/
                p: 1,
                s: 20
            }, cascaderValue: []
        }, () => {
            self.getData();
        })
    };

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    }

    CascaderChange = (value, selectedOptions) => {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                detailCode: selectedOptions[2].value
            },
            cascaderValue: value
        });
    }


    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        // if (!self.state.searchObj.orgId) {
        //     openNotice('warning', '提货组织为必选项');
        //     return
        // }
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    /*获取列表数据*/
    getData() {
        const self = this;
        const {searchObj} = this.state;
        list(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.data.total, rows: res.data.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    render() {
        const {
            rows,
            total,
            searchObj,
            stock_type,
            inv_type,
            objType_type,
            objDetail,
            middleData,
            loading,
            tree,
            cascaderValue
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'orgId',
                    label: '提货组织',
                    text: '输入提货组织',
                    options: stock_type,
                    defaultValue: searchObj.stock,
                    showSearch: true,
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'objCode',
                    label: '物料编码',
                    text: '输入物料编码',
                    defaultValue: searchObj.objCode,
                    type: 'default'
                },
                {
                    name: 'objDiscription',
                    label: '物料名称',
                    text: '输入物料名称',
                    defaultValue: searchObj.objName,
                    type: 'default'
                }, {
                    name: 'stockType',
                    label: '库存属性',
                    text: '输入库存属性',
                    options: inv_type,
                    defaultValue: searchObj.invType,
                    showSearch: true,
                    multiple: false,//支持多选
                    type: 'select'
                }
                /*,
                                {
                                    name: 'middleCode',
                                    label: '物料类别',
                                    text: '选择物料类别',
                                    options: objType_type,
                                    defaultValue: searchObj.objType,
                                    multiple: false,//支持多选
                                    showSearch: true,
                                    type: 'select'
                                },
                                {
                                    name: 'detailCode',
                                    label: '物料明细类',
                                    text: '物料明细类',
                                    options: objDetail,
                                    defaultValue: searchObj.detailType,
                                    multiple: false,//支持多选
                                    showSearch: true,
                                    type: 'select',
                                },*/


            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'RN',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 120,
                    render: (text, record, index) => {
                        if (record.stockType == "专属定制") {
                            return '***';
                        } else {
                            return text;
                        }
                    }
                }, {
                    title: '物料名称',
                    dataIndex: 'itemDesc',
                    render: (text, record, index) => {
                        if (record.stockType == "专属定制") {
                            return '***';
                        } else {
                            return text;
                        }
                    }
                }, {
                    title: '物料类别',
                    dataIndex: 'middleCate'
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '提货组织',
                    dataIndex: 'orgName'
                }
                , {
                    title: '子库存',
                    dataIndex: 'subinventory'
                }, {
                    title: '装箱数',
                    dataIndex: 'packageUnit'
                }, {
                    title: '最小内盒数',
                    dataIndex: 'minPackageUnit'
                }, {
                    title: '参考库存',
                    dataIndex: 'anhand',
                    render: (text, record, index) => {
                        return (
                            <span>{record.noshowOnhand ? '*' : text}</span>
                        );
                    }
                }, {
                    title: '面价',
                    dataIndex: 'price',
                    render: (text, record, index) => {
                        if (record.stockType == "专属定制") {
                            return '***';
                        } else {
                            return text;
                        }
                    }
                }, {
                    title: '库存属性',
                    dataIndex: 'stockType'
                }, {
                    title: '生产周期',
                    dataIndex: 'productionCycle'
                }, {
                    title: '状态',
                    dataIndex: 'itemStatus'
                }, {
                    title: 'AB分类',
                    dataIndex: 'abType'
                }

                //客户暂时不要这个数据
                /*   {
                       title: '金额',
                       dataIndex: 'money',
                       render:(text ,record,index)=>{
                           return record.price*record.anhand;
                       }
                   },*/
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={[`库存查询`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <div style={{paddingLeft: '40px', marginBottom: '10px'}}>
                        <label>产品分类：</label>
                        <Cascader style={{width: '550px'}} options={tree}
                                  value={cascaderValue}
                                  onChange={this.CascaderChange.bind(this)}
                                  placeholder="请选择产品分类"
                                  showSearch={{filter: this.CascaderFilter}}
                        /></div>
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>

            <div className="dms-table-box">
                <TableView {...tableViewProps}/>
                {/*<div className="order_amount">
                      <p><span className="right">现有量总计：1490</span></p>
                      <p><span className="right">金额总计：1399221.34</span></p>
                  </div>*/}
            </div>
        </div>
    }
}

export default withRouter(CustomerManagement);


// WEBPACK FOOTER //
// ./src/routes/inventoryQuery/list.js